import axiosInstance from "../../../core/api/axios";
import { useThemeStore } from "../stores/themeStore";

export async function getTheme(slug: string) {
  try {
    const theme = useThemeStore.getState().theme;
    const setTheme = useThemeStore.getState().setTheme;

    if(theme?.slug !== slug) {
      const { data } = await axiosInstance.get(`/essaythemes/${slug}`)

      setTheme(data)
    }
    
    return "ok";
  } catch(e: any) {
    throw new Error(e);
  }
}
